
import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { addActionEtatFailure, addActionEtatStart, addActionEtatSuccess, addActionFailure, addActionStart, addActionSuccess, getCartEnvoieFailure, getCartEnvoieStart, getCartEnvoieSuccess } from './CartActions'


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const addAction = async (dispatch, statusEnvoieId, list, agenceDepartId, agenceArrivedId, deliveryId, description) => {
    dispatch(addActionStart())
    let actionBody = { type: statusEnvoieId, agence: agenceDepartId, agenceArrived: agenceArrivedId, delivery: deliveryId, description };

    const small_list = list.map(item => {
        if (item.Entreprise) {
            return ({ idEnvoie: item.id, typeHistory: item.Histories[0].type, currentStatus: item.currentStatus, idHistory: item.Histories[0].id, userOwner: item.UserId, ramassagePromotion: item.Entreprise.ramassagePromotion, depotPromotion: item.Entreprise.depotPromotion, isEntreprise: true });
        } else {
            return ({ idEnvoie: item.id, typeHistory: item.Histories[0].type, currentStatus: item.currentStatus, idHistory: item.Histories[0].id, userOwner: item.UserId, ramassagePromotion: 0, depotPromotion: 0, isEntreprise: false });
        }
    }
    );
    const small_list2 = list.map(item => {
        if (item.Histories[1]) {
            if (item.Histories[1].type === 10) {
                return { idEnvoie: item.id, typeEnvoie: 10, agenceEnvoie: null }
            } else {
                return { idEnvoie: item.id, typeEnvoie: item.Histories[1].Action.type, agenceEnvoie: item.Histories[1].Action.agenceDepartId }
            }
        }
    })

    let cardBody = { actionBody, statusEnvoieId, small_list, small_list2 };
    try {
        const res = await axiosInstance.post(`/admin/cart`, cardBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addActionSuccess(res.data.message));
    } catch (err) {
        if (err.response) {
            dispatch(addActionFailure(err.response.data.message))
        } else {
            dispatch(addActionFailure("Unkown Error"))
        }
    }
}

export const addActioneEtat = async (dispatch, list, statusEnvoieId, motif, agence) => {
    dispatch(addActionEtatStart());
    let small_list = list.map(item => item.id);
    let small_list2 = list.map(item => ({ idEnvoie: item.id, userOwner: item.UserId }));
    let cardBody = { statusEnvoieId, motif, agence, small_list, small_list2 };
    try {
        const res = await axiosInstance.post(`/admin/cart/updateEnvoieStatus`, cardBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addActionEtatSuccess(res.data.message));
    } catch (err) {
        if (err.response) {
            dispatch(addActionEtatFailure(err.response.data.message))
        } else {
            dispatch(addActionEtatFailure("Unkown Error"))
        }
    }
}


export const getOneCartEnvoie = async (dispatch, id, typeActionEnvoie, userAgence, newEnvoieStatus) => {
    dispatch(getCartEnvoieStart());
    try {
        const res = await axiosInstance.get(`/admin/envois/bytracking/${id}`, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });

        if (newEnvoieStatus === 2) {
            if (res.data.envoie.typeEnvoie !== 1 || res.data.envoie.currentStatus !== 1) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de type Accusé de reception et NWE"))
                return
            }
        }
        if (newEnvoieStatus !== 2 && res.data.envoie.dead === 1) {
            dispatch(getCartEnvoieFailure("Cette envoie est bloqué"))
            return
        }
        if (newEnvoieStatus === 3 || newEnvoieStatus === 4) {
            if (res.data.envoie.currentStatus !== 1) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de status NWE"))
                return
            }
        }
        if (typeActionEnvoie === 1 || typeActionEnvoie === 2) {
            if (res.data.envoie.type !== 10) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de type Preparation"))
                return
            }
            if (typeActionEnvoie === 1 && res.data.envoie.typeRamassage === 2) {
                dispatch(getCartEnvoieFailure("Type de dépot est en agence"))
                return
            }
            if (typeActionEnvoie === 2 && res.data.envoie.typeRamassage === 1) {
                dispatch(getCartEnvoieFailure("Type de dépot est a domicile"))
                return
            }
        }
        if (typeActionEnvoie === 8) {
            if (res.data.envoie.type !== 1) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de type Ramassage"))
                return
            }
        }
        if (typeActionEnvoie === 3) {
            if (res.data.envoie.type !== 8 && res.data.envoie.type !== 2 && res.data.envoie.type !== 4 && res.data.envoie.type !== 9) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de type Réception Agence, Dépot Client, Centre ou Stock Agence"))
                return
            }
        }
        if (typeActionEnvoie === 4) {
            if (res.data.envoie.type !== 3) {
                dispatch(getCartEnvoieFailure("Vous devez choisir les envois de type Dispatch"))
                return
            }
            if (res.data.envoie.agence === userAgence) {
                dispatch(getCartEnvoieFailure("L'agence de départ et l'agence d'arrivée doivent être différentes"))
                return
            }
        }
        if (typeActionEnvoie === 5 || typeActionEnvoie === 6) {
            if (!res.data.envoie.agence || res.data.envoie.agence !== userAgence) {
                dispatch(getCartEnvoieFailure("Vous devez avoir l'envoie avant livré"))
                return
            }
            if (res.data.envoie.currentStatus === 1) { // aplly exclusively to NWE
                if (typeActionEnvoie === 5 && res.data.envoie.typeDelivery === 2) {
                    dispatch(getCartEnvoieFailure("Type de livraison est en agence"))
                    return
                }
                if (typeActionEnvoie === 6 && res.data.envoie.typeDelivery === 1) {
                    dispatch(getCartEnvoieFailure("Type de livraison est a domicile"))
                    return
                }
            }
        }

        dispatch(getCartEnvoieSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getCartEnvoieFailure(err.response.data.message))
        } else {
            dispatch(getCartEnvoieFailure("Unkown Error"))
        }
    }
}